export const selectionErrors: Record<string, string> = {
	selection_unknown_problem:
		'Модель выбрала задачу вне доступного набора. Интервью не началось.',
	selection_problem_out_of_pool:
		'Модель выбрала неподходящую задачу. Интервью не началось.',
	selection_invalid_choice:
		'Не удалось подобрать корректные задачи. Начните подбор заново.',
	selection_duplicate_problem:
		'При подборе получились одинаковые задачи. Начните подбор заново.',
	selection_invalid_output:
		'Не удалось обработать результат подбора. Начните подбор заново.',
	selection_pool_insufficient:
		'Для этого интервью пока недостаточно подходящих задач. Обратитесь к куратору.',
	selection_context_too_large:
		'Не удалось подготовить данные для подбора. Обратитесь к куратору.',
	selection_config_invalid:
		'Настройки подбора требуют проверки. Обратитесь к куратору.',
	selection_catalog_changed:
		'Список доступных задач изменился. Начните подбор заново.',
	selection_timeout: 'Время ожидания подбора истекло. Начните подбор заново.',
	selection_upstream_error:
		'Сервис подбора временно недоступен. Попробуйте начать заново.',
	selection_credits_exhausted:
		'На балансе недостаточно средств для подбора задач. Пополните баланс и начните интервью заново.',
	selection_internal_error:
		'Не удалось завершить подбор. Попробуйте начать заново.',
	selection_access_denied:
		'У вашего аккаунта больше нет доступа к этому интервью.',
};

export function selectionErrorMessage(code?: string) {
	return (
		(code && selectionErrors[code]) ||
		'Не удалось подобрать задачи. Попробуйте начать заново.'
	);
}

export function selectionPending(selection?: { status: string }) {
	return selection?.status === 'queued' || selection?.status === 'running';
}

/** Persist an uncertain start across page reloads. Only a confirmed outcome clears it. */
export function selectionRequestKey(
	storage: Pick<Storage, 'getItem' | 'setItem'> | undefined,
	key: string,
	previous: string | undefined,
	create: () => string,
) {
	if (previous) return previous;
	let value: string | null = null;
	try {
		value = storage?.getItem(key) ?? null;
	} catch {
		/* Memory remains usable. */
	}
	if (!value || value.length > 128) value = create();
	try {
		storage?.setItem(key, value);
	} catch {
		/* Storage is optional. */
	}
	return value;
}
